<ng-container *transloco="let t">
  <tui-block-status>
    <pxc-loader tuiSlot="top" [status]="(isStatusChecking$ | async) ? Status.LOADING : Status.ERROR" [useLogo]="true" />
    <h1>{{ t('Service indisponible') }}</h1>
    <p>
      {{ t('Veuillez nous excuser pour la gêne occasionnée.') }}
      <br />
      {{ t('Merci de réessayer dans quelques instants.') }}
    </p>
    <button
      appearance="primary"
      tuiButton
      type="button"
      [loading]="isStatusChecking$ | async"
      (click)="retryConnection()">
      {{ t('Réessayer') }}
    </button>
  </tui-block-status>
</ng-container>
